import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InsightsIcon from '@mui/icons-material/Insights';
import PreviewIcon from '@mui/icons-material/Preview';
import BoltIcon from '@mui/icons-material/Bolt';
import { DELETE, EDIT, FormListEvent, PREVIEW, STATS, SAMPLE } from '../forms-list-events';
import { IconButton, Tooltip } from '@mui/material';
import { DynamicFormDefinition } from 'src/common';
import { useContext } from 'react';
import { DependencyInjectionContext } from '../../../../contexts/dependency-injection-context';

const ActionList = ({ data, callback, clientId }: {
    data: DynamicFormDefinition,
    callback: (event: FormListEvent, form: DynamicFormDefinition, clientId: string | undefined) => void,
    clientId: string | undefined
}) => {

    const { applicationState } = useContext(DependencyInjectionContext);

    return (
        <span>
            <Tooltip title="Preview">
                <IconButton onClick={() => callback(PREVIEW, data, applicationState.selectedClientId)}>
                    <PreviewIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Edit">
                <IconButton onClick={() => callback(EDIT, data, applicationState.selectedClientId)}><EditIcon /></IconButton>
            </Tooltip>

            <Tooltip title="Stats">
                <IconButton onClick={() => callback(STATS, data, applicationState.selectedClientId)}><InsightsIcon /></IconButton>
            </Tooltip>

            <Tooltip title="Delete">
                <IconButton onClick={() => callback(DELETE, data, applicationState.selectedClientId)}>
                    <DeleteIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Generate Sample">
                <IconButton onClick={() => callback(SAMPLE, data, applicationState.selectedClientId)}>
                    <BoltIcon />
                </IconButton>
            </Tooltip>
        </span>
    );
};

export default ActionList;